import {
    Box,
    Container,
    Flex,
    Grid,
    GridItem,
    Heading,
    Link,
    Stack,
    Text,
    VStack,
} from "@chakra-ui/react";
import Head from "next/head";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const TerminosCondicionesPagoComprasOnline = () => {
    return (
        <Container maxWidth="100vw" pt={{ base: 14, md: 24 }} px={{ base: 4, lg: 7 }}>
            <Header />
            <Head>
                <title>
                    Terminos y Condiciones para la Seleccion de Forma de Pago en Compras en Linea|
                    Grupo Guia
                </title>
            </Head>
            <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                <GridItem colSpan={1} display={{ base: "none", md: "block" }} fontSize="16px">
                    <Stack mt="28" mb={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones"
                        >
                            Terminos y condiciones Contratación del portal
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiabroker"
                        >
                            Terminos y condiciones Guía broker
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiarent"
                        >
                            Terminos y condiciones Guía Rent
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/politicanodiscriminacion"
                        >
                            Política de no discriminación
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/cartaderechosconsumidor"
                        >
                            Carta de derechos del consumidor
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiaconnect"
                        >
                            Términos y condiciones Guia Connect
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-soyinmobiliaria"
                        >
                            Terminos y condiciones Soy Inmobiliaria
                        </Link>
                    </Stack>
                    <Stack my={4} borderLeftColor="#17669D" borderLeftWidth="3px" pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-pagocomprasonline"
                        >
                            Términos y Condiciones para la Selección de Forma de Pago en Compras en
                            Línea
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-alianzas"
                        >
                            Términos y Condiciones - Guía Alianzas
                        </Link>
                    </Stack>
                </GridItem>
                <GridItem colSpan={{ base: 4, md: 3 }}>
                    <Box mb="4" mt="24">
                        <Heading
                            as="h1"
                            fontSize={{ md: "4xl", base: "2xl" }}
                            mb="8"
                            color="accent.500"
                            fontWeight="bold"
                            lineHeight={1.2}
                        >
                            Términos y Condiciones para la Selección de Forma de Pago en Compras en
                            Línea
                        </Heading>
                    </Box>
                    <Box lineHeight="2" mb="12">
                        <Text
                            mb={6}
                            fontWeight="bold"
                            fontSize="2xl"
                            color="accent.500"
                            lineHeight={1.2}
                        >
                            1. Selección de forma de pago al realizar la compra
                        </Text>
                        <Flex my={4}>
                            <Text>
                                Al momento de realizar la compra en línea, es obligatorio
                                seleccionar una forma de pago para el saldo restante del
                                departamento (saldo a la escritura). En caso de que el saldo sea
                                igual o superior al 50%, aplican las siguientes condiciones:
                            </Text>
                        </Flex>
                        <VStack spacing={6} mt={7} align="flex-start" color="accent.500">
                            <Text>
                                <strong>
                                    · Pago con crédito hipotecario:
                                    <br />{" "}
                                </strong>
                                Si el saldo a la escritura será cubierto, total o parcialmente,
                                mediante crédito hipotecario, el cliente deberá adjuntar una
                                precalificación crediticia al seleccionar esta forma de pago. Este
                                documento es necesario para garantizar que el cliente es sujeto de
                                crédito y que podrá cumplir con la obligación de pago. <br />
                                <br />
                                En caso de que el cliente no cuente con un broker hipotecario o
                                requiera apoyo para el trámite del crédito, puede ingresar
                                directamente a la página web https://grupoguia.mx/guialink/, donde
                                se le brindará asesoría personalizada y todo el apoyo necesario para
                                la gestión y trámite del crédito hipotecario sin ningún costo por
                                este servicio
                            </Text>
                            <Text>
                                <strong>
                                    · Pago con recurso propio:
                                    <br />{" "}
                                </strong>
                                {`Si el saldo a la escritura será cubierto totalmente con recursos
                                    propios, no será necesario adjuntar la precalificación crediticia.
                                    Sin embargo, el cliente deberá seleccionar la opción "Recurso
                                    propio" en la lista desplegable correspondiente.`}
                            </Text>
                        </VStack>
                        <Text
                            my={6}
                            fontWeight="bold"
                            fontSize="2xl"
                            color="accent.500"
                            lineHeight={1.2}
                        >
                            2. Cambios en la forma de pago
                        </Text>
                        <Flex my={4}>
                            <Text>
                                El cliente tiene la posibilidad de modificar la forma de pago
                                seleccionada en una etapa posterior, sujeto a las siguientes
                                condiciones:
                            </Text>
                        </Flex>
                        <VStack spacing={6} mt={7} align="flex-start" color="accent.500">
                            <Text ml={2}>
                                · El cambio debe ser notificado al vendedor con al menos{" "}
                                <strong>tres (3) meses de anticipación</strong> a la fecha
                                programada para la escritura de la unidad privativa.
                                <br />
                                · Si el nuevo método de pago incluye un crédito hipotecario, el
                                cliente deberá presentar la precalificación crediticia
                                correspondiente y proporcionar los datos de contacto de su broker
                                hipotecario y la institución financiera que otorgará el crédito.
                                <br />· Si el cliente necesita apoyo para gestionar el crédito
                                hipotecario, puede utilizar el servicio de GuiaLink disponible en
                                https://grupoguia.mx/guialink/.
                            </Text>
                        </VStack>
                        <Text my={6} fontWeight="bold" fontSize="2xl" color="accent.500">
                            3. Requisitos adicionales
                        </Text>
                        <VStack spacing={6} mt={7} align="flex-start" color="accent.500">
                            <Text ml={2}>
                                · El cliente es responsable de garantizar que la información
                                proporcionada sea verídica y de cumplir con todos los requisitos
                                asociados al método de pago seleccionado.
                                <br />· En caso de no cumplir con las condiciones estipuladas o los
                                plazos establecidos para la notificación y entrega de documentación,
                                el cliente será responsable de cualquier demora en la firma de la
                                escritura u otros inconvenientes relacionados con el proceso de
                                compra.
                            </Text>
                        </VStack>
                        <Text my={6} fontWeight="bold" fontSize="2xl" color="accent.500">
                            4. Aceptación de términos
                        </Text>
                        <VStack spacing={6} mt={7} align="flex-start" color="accent.500">
                            <Text>
                                Al realizar la compra en línea y seleccionar la forma de pago, el
                                cliente declara haber leído y aceptado estos términos y condiciones,
                                comprometiéndose a cumplir con las disposiciones aquí establecidas.
                            </Text>
                        </VStack>
                    </Box>
                </GridItem>
            </Grid>
            <Footer visible={false} />
        </Container>
    );
};

export default TerminosCondicionesPagoComprasOnline;
